import Vue from 'vue'
import Vuetify, { VList } from 'vuetify/lib'
import theme from './theme';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdiSvg",
  },
  theme: {
    themes: {
      light: theme,
      dark: theme,
    },
    options: {
      customProperties: true,
    },
  },
  components: {
      VList,
  },
});
